import React, { useEffect, useState } from "react";
import "../DashboardStyles.css";
import PADDLogo from "./PADDLogo";

import Chapter1   from "./Chapter1Dashboard";
import Chapter2   from "./Chapter2Dashboard";
import Chapter3   from "./Chapter3Dashboard";
import Chapter4   from "./Chapter4Dashboard";
import Chapter5   from "./Chapter5Dashboard";
import Chapter6   from "./Chapter6Dashboard";
import Chapter7   from "./Chapter7Dashboard";
import Chapter8   from "./Chapter8Dashboard";
import Chapter9   from "./Chapter9Dashboard";
import Chapter10  from "./Chapter10Dashboard";
import Chapter11  from "./Chapter11Dashboard";
import Appendix   from "./AppendixReference";
import Survey     from "./SurveyDashboard";
import Tracker    from "./CedsTracker";
import Broadband  from "./BroadbandDashboard";

const NAV_ITEMS = [
  { key: "ch1",   label: "Ch 1",        ariaLabel: "Chapter 1: Executive Summary",             component: Chapter1  },
  { key: "ch2",   label: "Ch 2",        ariaLabel: "Chapter 2: Population and Demographics",   component: Chapter2  },
  { key: "ch3",   label: "Ch 3",        ariaLabel: "Chapter 3: Natural Assets",                  component: Chapter3  },
  { key: "ch4",   label: "Ch 4",        ariaLabel: "Chapter 4: Infrastructure",                  component: Chapter4  },
  { key: "ch5",   label: "Ch 5",        ariaLabel: "Chapter 5: Regional Economy",                component: Chapter5  },
  { key: "ch6",   label: "Ch 6",        ariaLabel: "Chapter 6: Quality of Life",                 component: Chapter6  },
  { key: "ch7",   label: "Ch 7",        ariaLabel: "Chapter 7: Higher Education and Workforce",  component: Chapter7  },
  { key: "ch8",   label: "Ch 8",        ariaLabel: "Chapter 8: Regional SWOT Analysis",          component: Chapter8  },
  { key: "ch9",   label: "⭐ Action Plan", ariaLabel: "Chapter 9: Regional Action Plan",        component: Chapter9  },
  { key: "ch10",  label: "Ch 10",       ariaLabel: "Chapter 10: Resiliency",                   component: Chapter10 },
  { key: "ch11",  label: "Ch 11",       ariaLabel: "Chapter 11: Public Engagement, Community Input & the Planning Climate", component: Chapter11 },
  { key: "appx",  label: "Appendix",    ariaLabel: "Appendices A–D: Data Sources, Strategy Council, Acronyms, E Pluribus Unum", component: Appendix, isAppendix: true },
  { key: "survey", label: "📋 Survey",  ariaLabel: "Community Survey Results",                    component: Survey,   isSurvey: true },
  { key: "tracker",   label: "📊 Tracker",   ariaLabel: "CEDS Performance Tracker",        component: Tracker,   isTracker:   true },
  { key: "broadband", label: "📡 BEAD",      ariaLabel: "Nebraska BEAD Broadband Infrastructure", component: Broadband, isBroadband: true },
];

const VALID_KEYS = new Set(NAV_ITEMS.map((n) => n.key));

export default function MasterDashboard() {
  const urlTab = new URLSearchParams(window.location.search).get("tab");
  const [active, setActive] = useState(VALID_KEYS.has(urlTab) ? urlTab : "ch1");

  // Each tab opens at the top rather than at the previous tab's scroll position
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [active]);

  const ActiveComponent = NAV_ITEMS.find((n) => n.key === active)?.component ?? Chapter1;

  return (
    <>
      {/* ── Skip navigation link (WCAG 2.4.1) ──────────────────── */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <div className="page-shell">
        {/* ── Top navigation ──────────────────────────────────────── */}
        <header className="topnav-wrapper">
          <div className="topnav-inner">
            {/* Brand */}
            <PADDLogo iconSize={32} variant="compact" />
            <div className="topnav-sep" aria-hidden="true" />

            {/* Chapter nav */}
            <nav aria-label="CEDS chapter navigation">
              <div className="topnav-items" role="list">
                {NAV_ITEMS.map((item) => (
                  <button
                    key={item.key}
                    role="listitem"
                    onClick={() => setActive(item.key)}
                    aria-label={item.ariaLabel}
                    aria-current={active === item.key ? "page" : undefined}
                    className={[
                      "topnav-btn",
                      item.key === "ch9"   ? "topnav-btn--action"   : "",
                      item.isAppendix      ? "topnav-btn--appendix" : "",
                      item.isSurvey        ? "topnav-btn--survey"   : "",
                      item.isTracker       ? "topnav-btn--tracker"    : "",
                      item.isBroadband     ? "topnav-btn--broadband" : "",
                      active === item.key  ? "topnav-btn--active"   : "",
                    ].filter(Boolean).join(" ")}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </nav>
          </div>
        </header>

        {/* ── Page content ────────────────────────────────────────── */}
        <main
          className="page-content"
          id="main-content"
          tabIndex="-1"
          aria-label={NAV_ITEMS.find((n) => n.key === active)?.ariaLabel}
        >
          <ActiveComponent />
        </main>

        {/* ── Footer ──────────────────────────────────────────────── */}
        <footer className="page-footer">
          <span>Panhandle Area Development District · 2026–2031 CEDS</span>
          <span>Source data: U.S. Census Bureau · BEA · BLS · USDA</span>
        </footer>
      </div>
    </>
  );
}
